export const FilterCategoryTitle = ({ title }: { title: string }) => (
  <span className="mb-2 block w-full text-sm font-semibold text-ink dark:text-ink-dark">
    {title}
  </span>
);
